export default "__VITE_ASSET__DHNCY_j___"